export default __webpack_public_path__ + "static/media/ipod.90f2c275.png";